<template>
  <div v-if="isValidUser">
    <NavDrawerV01
      color="#223448"
      dark
      fixed
      height="100vh"
      id="nav-bar-drawer"
      mini-variant-width="80px"
      mobile-breakpoint="0"
      width="202px"
      :mini-variant="mini"
    >
      <template v-slot:prepend>
        <NavBarHeader
          :mini="mini"
          @toggleMini="mini = !mini"
        />
      </template>
      <template v-slot:default>
        <NavBarContent
          :disabledLinks="disabledLinks"
          :mini="mini"
          :shouldShowDataManagement="shouldShowDataManagement"
          :user="user"
          @collapseNavBar="mini = showOverlay"
          @expandNavBar="mini = false"
        />
      </template>
      <template v-slot:append>
        <NavBarFooter
          :mini="mini"
          :user="user"
        />
      </template>
    </NavDrawerV01>
    <transition name="fade">
      <div
        v-if="!mini && showOverlay"
        class="overlay"
        @click="mini = true">
      </div>
    </transition>
  </div>
</template>

<script>
import NavBarContent from '../components/NavBarContent';
import NavBarFooter from '../components/NavBarFooter';
import NavBarHeader from '../components/NavBarHeader';
import { NavDrawerV01 } from '@mikmak/components';

export default {
  components: {
    NavBarContent,
    NavBarFooter,
    NavBarHeader,
    NavDrawerV01,
  },
  props: {
    shouldShowDataManagement: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disabledLinks: [],
      currentWindowInnerWidth: 0,
      mini: false,
      showOverlay: false,
    };
  },
  created() {
    window.addEventListener('disabled-links:changed', this.handleDisabledLinks);
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('disabled-links:changed', this.handleDisabledLinks);
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  computed: {
    isValidUser() {
      return this.user && Object.keys(this.user).length;
    },
    user() {
      return this.$auth?.user || this.userFromLocalStorage;
    },
    userFromLocalStorage() {
      try {
        return JSON.parse(window.localStorage.getItem('mm-platform-user'));
      } catch (e) {
        return undefined;
      }
    },
  },
  methods: {
    handleDisabledLinks(event) {
      this.disabledLinks = event?.detail?.disabledLinks || [];
    },
    handleResize() {
      const { innerWidth } = window;

      this.showOverlay = innerWidth < 1000;

      this.updateMiniAndInnerWidth(innerWidth);
    },
    updateMiniAndInnerWidth(newWindowInnerWidth) {
      if (this.currentWindowInnerWidth !== newWindowInnerWidth) {
        this.mini = newWindowInnerWidth < 1000;
        this.currentWindowInnerWidth = newWindowInnerWidth;
      }
    },
  },
};
</script>

<style scoped>
.overlay {
  z-index: 3;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

::v-deep #nav-bar-drawer {
  position: absolute;
}
</style>
